import React, { useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { displayVersion } from "./utils/console-reporting";
import Routes from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import theme from "./theme";
import { queryClient } from "./lib/queryClient";
import DevToolsBlocker from "./components/Shared/DevToolsBlocker";

const App: React.FC = () => {
  useEffect(() => {
    displayVersion();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <DevToolsBlocker />
        <Provider store={store}>
          <PersistGate loading={<>Loading...</>} persistor={persistor}>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </MantineProvider>
    </QueryClientProvider>
  );
};

export default App;
